import {ValueObject} from '@s-ui/domain'

export class FaqsValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array} params.items
   * */
}
